import { render, staticRenderFns } from "./BenefitVoucherDetailsModal.vue?vue&type=template&id=faf4a86a&"
import script from "./BenefitVoucherDetailsModal.vue?vue&type=script&lang=js&"
export * from "./BenefitVoucherDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports